import React, { ReactNode } from 'react';
import { ColorValue, StyleProp, View, ViewStyle } from 'react-native';
import type { MissionPromotionDisplayDto } from '../../../api/api.g';
import useStyles from '../../../hooks/styles-hook';
import type { MoreInfoButtonProps } from '../MoreInfoButton';
import MissionRemunerationSummary from './MissionRemunerationSummary';
import { MissionPromotionSummary } from './MissionPromotion';
import MissionPurchaseConditions, { MissionPurchaseConditionsValue } from './MissionPurchaseConditions';

interface MissionCompensationProps {
  compensation: MissionPurchaseConditionsValue & {
    salaryAmount?: number | string;
    salaryPoints?: number;
    promotionDisplay?: MissionPromotionDisplayDto;
  };
  purchaseConditions?: MissionPurchaseConditionsValue;
  pointsOnly?: boolean;
  settled?: boolean;
  salaryLabel?: string;
  containerStyle?: StyleProp<ViewStyle>;
  rowStyle?: StyleProp<ViewStyle>;
  textColor?: ColorValue;
  iconColor?: ColorValue;
  helpColor?: string;
  moreInfoButtonProps?: Pick<MoreInfoButtonProps, 'suspendDrawerOnOpen' | 'useLightBoxOnNative' | 'onOpen'>;
  afterReward?: ReactNode;
  children?: ReactNode;
}

const MissionCompensation = ({ compensation, purchaseConditions, pointsOnly = false, settled = false,
  salaryLabel, containerStyle, rowStyle, textColor, iconColor, helpColor, moreInfoButtonProps, afterReward, children }: MissionCompensationProps) => {
  const styles = useStyles(section => section.missionDetailCard);
  const conditions = purchaseConditions ?? compensation;
  return <View testID="mission-compensation" style={[
    styles.missionsBranchDetail.content.infoContainer.summary,
    { width: '100%', minWidth: 0, flexDirection: 'column', flexWrap: 'nowrap' }, containerStyle,
  ]}>
    <MissionRemunerationSummary amount={compensation.salaryAmount} points={compensation.salaryPoints ?? 0}
      pointsOnly={pointsOnly} label={salaryLabel} textColor={textColor} iconColor={iconColor} helpColor={helpColor}
      totalPaymentMaxAmount={settled ? undefined : conditions.totalPaymentMaxAmount}
      rowStyle={rowStyle} moreInfoButtonProps={moreInfoButtonProps} />
    {afterReward}
    <MissionPromotionSummary display={compensation.promotionDisplay} color={textColor} iconColor={iconColor} />
    <MissionPurchaseConditions conditions={conditions} settled={settled}
      showReimbursementPoints={!pointsOnly} textColor={textColor} iconColor={iconColor} helpColor={helpColor}
      rowStyle={rowStyle} moreInfoButtonProps={moreInfoButtonProps} />
    {children}
  </View>;
};

export default MissionCompensation;
